import { render, staticRenderFns } from "./FareRule.vue?vue&type=template&id=dafb0e26&"
import script from "./FareRule.vue?vue&type=script&lang=js&"
export * from "./FareRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports